import { PaginationAndSortingParameters, SortDirection, SortingParameters } from 'api';
import { TableState } from 'types';

export function getPaginationParameters<T extends object>(
  query: TableState<T, object | undefined>
): PaginationAndSortingParameters {
  return {
    pagination: {
      page: query.pageIndex + 1,
      pageSize: query.pageSize,
    },
    sorting: query.sortBy[0]?.id
      ? {
          sortField: query.sortBy[0]?.id ?? '',
          sortDir: query.sortBy[0]?.desc
            ? SortDirection.Desc
            : query.sortBy[0]?.desc === false
              ? SortDirection.Asc
              : SortDirection.Undefined,
        }
      : (null as unknown as SortingParameters),
    isSortingSpecified: query.sortBy.length > 0,
    isPaginationSpecified: query.pageIndex !== 0 || query.pageSize !== 10,
  };
}
